import React, {useState,useEffect,useContext,useCallback} from 'react'

import {Typography,DatePicker,Select,Radio,Divider, Spin, Avatar, Menu, Dropdown, Form, Card, Drawer, Layout, Tabs, Button, Input, Space,Row, Col} from "antd";
import InfiniteScroll from 'react-infinite-scroller';
import Highlighter from 'react-highlight-words';
import {errorN} from "../../general";
import { A,navigate} from "hookrouter";
import useFetch from "use-http";
import {
    BellOutlined ,
    ProfileOutlined ,
    SolutionOutlined ,
    PhoneOutlined ,
    HomeOutlined,
    ControlOutlined ,
    DollarOutlined ,
    ContainerOutlined ,
    MinusSquareOutlined ,
    BorderOutlined ,
    RightCircleOutlined,
    SearchOutlined,
    FileExcelOutlined


} from '@ant-design/icons'

import routes from "../../router"
import Store, {Context} from "../../store"
import moment from 'moment'
import FModal from "../Bookings/modal";

import { Table } from "ant-table-extensions";

const {Sider, Content,Footer } = Layout;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Text } = Typography;

const formatter = new Intl.NumberFormat('en-MY', {
    //style: 'currency',
    //currency: 'MYR',
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function Guests(props) {
    const [state,dispatch] = useContext(Context)
    const { get, post, response, loading, error, del, put } = useFetch()
    const [drawOpen, setDrawOpen] = useState(false);

    const [form] = Form.useForm()
    const [formLayout, setFormLayout] = useState('vertical');
    const handleFinish = useCallback(() => {
        console.log('Submit: ', form.getFieldsValue(true));

        const values = form.getFieldsValue(true);

    }, [form])

    const [dateRange, setDateRange] = useState(false);
    const [keyword, setKeyword] = useState(false);
    const [arrivalDate, setArrivalDate] = useState(false);
    const [arrivalDateRange, setArivalDateRange] = useState(false);

    const [data, setData] = useState([]);

    const [searchText, setsearchText]= useState( '');
    const [searchedColumn, setsearchedColumn]= useState( '');

    const [sourceFilters,setSourceFilters] = useState([]);
    const [statusFilters,setStatusFilters] = useState([]);
    const [agencyFilters,setAgencyFilters] = useState([]);
    const [nationalityFilters,setNationalityFilters] = useState([]);

    const labelCol = 22;
    const wrapperCol = 22;

    async function removeDuplicates(data) {
        // let unique = data.reduce(function(a,b){
        //   if(a.indexOf(b) < 0) a.push(b);
        //   return a;
        // },[]);

        const unique = data.filter((thing, index) => {
            const _thing = JSON.stringify(thing);
            return index === data.findIndex(obj => {
              return JSON.stringify(obj) === _thing;
            });
          });

        return unique;
      };

    let searchInput = null;
    const getColumnSearchProps = (dataIndex,caption) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={node => {
                    searchInput=node;
                }}
                placeholder={`Search ${caption}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </Space>
        </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
        record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
    onFilterDropdownVisibleChange: visible => {
        if (visible) {
            setTimeout(() => searchInput.select(), 100);
        }
    },
    render: text =>
        searchedColumn === dataIndex ? (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
});

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        /*this.setState({*/
            setsearchText(selectedKeys[0]);
            setsearchedColumn(dataIndex);
       /* });*/
    };

    const handleReset = clearFilters => {
        clearFilters();
        setsearchText('');
    };

    async function loadData() {
        form.validateFields().then(async values => {
            try
            {
                let obj = JSON.parse(localStorage.getItem('currentproperty'));

                let s = '';
                let e = '';
                let parameter = '';

                s = moment.utc(values.dtDateRange[0]).format('YYYY-MM-DD');
                e = moment.utc(values.dtDateRange[1]).format('YYYY-MM-DD');

                parameter = `?start=${s}T00:00:00Z&end=${e}T23:59:59Z`


                let rList = await get(`/api/hotels/${obj.id}/guests${parameter}`)
                if (response.ok){
                    let table1 =[];

                    for(let i of rList)
                    {
                        let x = ''
                        let xtype = '';
                        let paxno = 0;

                        if(i.allocation != null)
                        {
                            for (let j of i.allocation)
                            {
                                if (x === '')
                                {
                                    x = j.room.no;
                                    xtype = j.room.service.name;
                                }
                                else
                                {
                                    x = x + "," + j.room.no;
                                    xtype = xtype + "," + j.room.service.name;
                                }

                                paxno = paxno + j.data.paxno;

                            }
                        }

                        let en = moment(i.end);
                        let st = moment(i.start);


                        table1.push({
                            id: i.id,
                            no: i.no,
                            name: i.data.payor.name,
                            email: i.data.payor.email,
                            tel: i.data.payor.tel,
                            nationality: i.data.payor.nationality.name,
                            address: i.data.payor.address.line,
                            city: i.data.payor.address.city,
                            postcode: i.data.payor.address.postcode,
                            state: i.data.payor.address.state,
                            country: i.data.payor.address.country,
                            start: moment(i.start).format('YYYY-MM-DD'),
                            end: moment(i.end).format('YYYY-MM-DD'),
                            totalnights: en.diff(st, 'days'),
                            paxno: paxno,
                            roomno: x,
                            roomtype: xtype,
                            folioid: i.id
                        });
                    }


                    setData(table1);
                }
                else
                {
                    if(response.status === 401)
                    {
                        localStorage.removeItem('session');
                        window.location.reload();
                    }
                    else
                    {
                    errorN(`Load Data - ${response.status}: ${response.statusText}. Please contact the administrator.`);
                    }

                }
            }
            catch(err)
            {
                errorN(`Error Load Data: ${err}. Please contact the administrator.`);
            }

        })
    }

    useEffect(() => {


        if(localStorage.getItem('session') === null)
        {
            navigate('/')
        }
        else
        {
            loadData();
        }

        //loadData().then(r => {});


        return () => {

        }
    },[])


    const columns = [

        /*{
            width: '100px',
            title: '',
            dataIndex: 'action2',
            key: 'action2',
            render: (text, record) => (
                <>
                    <Space>
                        {record.folioid !== '' && record.folioid !== null && record.folioid !== undefined ?
                            <FModal formname={'update'} obj={{...record}} loadData={loadData} />
                            :
                            null
                        }
                    </Space>

                </>
            )
        },*/
        {
            width: '100px',
            title:"Folio No.",
            dataIndex:"no",
            key:"no",
            ...getColumnSearchProps('no','No'),
            sorter: (a, b) => a.no.localeCompare(b.no),
        },
        {
            width: '200px',
            title:"Name",
            dataIndex:"name",
            key:"name",
            ...getColumnSearchProps('name','Name'),
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            width: '150px',
            title:"Email",
            dataIndex:"email",
            key:"email",
            ...getColumnSearchProps('email','Email'),
            sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
            width: '100px',
            title:"Tel No.",
            dataIndex:"tel",
            key:"tel",
            ...getColumnSearchProps('tel','Tel No.'),
            sorter: (a, b) => a.tel.localeCompare(b.tel),
        },
        {
            width: '100px',
            title:"Nationality",
            dataIndex:"nationality",
            key:"nationality",
            ...getColumnSearchProps('nationality','Nationality'),
            sorter: (a, b) => a.nationality.localeCompare(b.nationality),
        },
        {
            width: '100px',
            title:"Nationality",
            dataIndex:"nationality",
            key:"nationality",
            ...getColumnSearchProps('nationality','Nationality'),
            sorter: (a, b) => a.nationality.localeCompare(b.nationality),
        },
        {
            width: '200px',
            title:"Address",
            dataIndex:"address",
            key:"address",
            ...getColumnSearchProps('address','Address'),
            sorter: (a, b) => a.address.localeCompare(b.address),
        },
        {
            width: '100px',
            title:"City",
            dataIndex:"city",
            key:"city",
            ...getColumnSearchProps('city','City'),
            sorter: (a, b) => a.city.localeCompare(b.city),
        },
        {
            width: '100px',
            title:"Postcode",
            dataIndex:"postcode",
            key:"postcode",
            ...getColumnSearchProps('postcode','Postcode'),
            sorter: (a, b) => a.postcode.localeCompare(b.postcode),
        },
        {
            width: '100px',
            title:"State",
            dataIndex:"state",
            key:"state",
            ...getColumnSearchProps('state','State'),
            sorter: (a, b) => a.state.localeCompare(b.state),
        },
        {
            width: '100px',
            title:"Country",
            dataIndex:"country",
            key:"country",
            ...getColumnSearchProps('country','Country'),
            sorter: (a, b) => a.country.localeCompare(b.country),
        },
        {
            width: '100px',
            title:"Country",
            dataIndex:"country",
            key:"country",
            ...getColumnSearchProps('country','Country'),
            sorter: (a, b) => a.country.localeCompare(b.country),
        },
        {
            width: '100px',
            title:"Arrival Date",
            dataIndex:"start",
            key:"start",
            ...getColumnSearchProps('start','Arrival Date'),
            sorter: (a, b) => a.start.localeCompare(b.start),
        },
        {
            width: '100px',
            title:"Dept. Date",
            dataIndex:"end",
            key:"end",
            ...getColumnSearchProps('end','Dept. Date'),
            sorter: (a, b) => a.end.localeCompare(b.end),
        },
        {
            width: '100px',
            title:"Total Night(s)",
            dataIndex:"totalnights",
            key:"totalnights",
            ...getColumnSearchProps('totalnights','Total Night(s)'),
            sorter: (a, b) => a.totalnights.localeCompare(b.totalnights),
        },
        {
            width: '100px',
            title:"No. of Pax",
            dataIndex:"paxno",
            key:"paxno",
            ...getColumnSearchProps('paxno','No. of Pax'),
            sorter: (a, b) => a.paxno.localeCompare(b.paxno),
        },
        {
            width: '100px',
            title:"Unit No.",
            dataIndex:"roomno",
            key:"roomno",
            ...getColumnSearchProps('roomno','Unit No.'),
            sorter: (a, b) => a.roomno.localeCompare(b.roomno),
        },
        {
            width: '100px',
            title:"Service Type",
            dataIndex:"roomtype",
            key:"roomtype",
            ...getColumnSearchProps('roomtype','Service Type'),
            sorter: (a, b) => a.roomtype.localeCompare(b.roomtype),
        },


    ]



    return (
        <>
        <div style={{ backgroundImage:`url("/header-bg7.png")`, color:'black', fontSize: '18px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
        &nbsp;&nbsp;<ProfileOutlined />
        &nbsp;&nbsp;In House Guest
        </div>
        <Layout>

            <Spin spinning={loading}>
            <Content style={{backgroundColor: 'white'}}>
                <Form
                    layout={formLayout}
                    form={form}
                    onFinish={handleFinish}

                >
                    <div style={{backgroundColor: 'white', padding: '20px', margin: '0px 0',height:'73vh',overflow:'auto'}}>
                    <InfiniteScroll
                        pageStart={0}
                        hasMore={true || false}
                        useWindow={false}
                    >
                    <div style={{backgroundColor: 'white', paddingRight: '20px',paddingLeft: '20px', paddingTop: '20px',marginRight: '20px'}}>
                    <Form.Item
                        style={{ display: 'none' }}
                        label="typex"
                        name="typex"
                        labelCol={{ span: labelCol }}
                        wrapperCol={{ span: wrapperCol }}
                        rules={[]}
                    >
                        <Input />
                    </Form.Item>

                        <Space>
                            <Form.Item
                                label="Arrival - Departure"
                                name="dtDateRange"
                                rules={[{ required: true, message: 'Dates missing!' }]}
                            >
                                <RangePicker />
                            </Form.Item>

                            <Button style={{marginTop:'7px'}} onClick={() => {loadData()}} key=""type="primary">Load</Button>
                        </Space>


                    </div>

                    <div rowKey="id" style={{backgroundColor: 'white', paddingRight: '20px',paddingLeft: '20px',paddingBottom: '20px', marginRight: '20px'}}>
                        <Table
                            defaultExpandAllRows={true}
                            columns={columns}
                            dataSource={data}
                            exportable
                            exportableProps={{ showColumnPicker: true, fileName: "In-House Guest-List",btnProps: {
                                    type: "primary",
                                    icon: <FileExcelOutlined />,
                                    /*children: <span>Export</span>,*/
                                } }}
                            searchable
                            searchableProps={{
                                // dataSource,
                                // setDataSource: setSearchDataSource,
                                inputProps: {
                                    placeholder: "Search this table...",
                                    prefix: <SearchOutlined />,
                                },
                            }}
                            //expandable={{expandedRowRender}}
                            bordered
                            size="small"
                            //expandRowByClick={false}
                            scroll={{ x: 1500,y: 360 }}
                            pagination={false}

                            /*footer={pageData => {
                                let totalAmount = 0;
                                //let totalReceived = 0;
                                //let totalBalance = 0;

                                pageData.forEach(({ amount, paid, balance }) => {
                                    totalAmount += parseFloat(amount);
                                    //totalReceived += parseFloat(paid);
                                    //totalBalance += parseFloat(balance);
                                });

                                return (
                                  <>
                                    <Text><b>Total Amount: {formatter.format(totalAmount)}</b></Text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Text><b>Total Received: {formatter.format(totalReceived)}</b></Text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Text type="danger"><b>Total Balance: {formatter.format(totalBalance)}</b></Text>

                                  </>
                                );
                              }}*/

                        />
                    </div>

                    </InfiniteScroll>
                    </div>
                </Form>
            </Content>
            </Spin>
        </Layout>
        {/* <div style={{ textAlign: 'center', fontSize: '14px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
        {`©${state.year} Managed by Ratri Cloud`}
        </div>   */}

        </>
    );
}

export default Guests
